import { OCR_MODEL_TIER_OPTIONS, type OcrModelTier } from '../api';

interface OcrModelTierSelectProps {
  value: OcrModelTier;
  onChange: (v: OcrModelTier) => void;
  disabled?: boolean;
}

/**
 * Labelled select for the per-DocumentType OCR model tier override.
 * «Automático» is the recommended default: the system picks the model based on
 * whether the schema contains table fields (Tables/layout) or not (TextOnly/read).
 * The other tiers are explicit overrides for edge-case schemas where the auto
 * inference would pick the wrong — or too expensive — model.
 */
export function OcrModelTierSelect({
  value,
  onChange,
  disabled = false,
}: OcrModelTierSelectProps): JSX.Element {
  return (
    <div>
      <label className="label" htmlFor="ocr-model-tier">
        Modelo OCR
      </label>
      <select
        id="ocr-model-tier"
        className="input"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as OcrModelTier)}
      >
        {OCR_MODEL_TIER_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <p className="mt-1 text-xs text-slate-500">
        Automático elige el modelo según si el tipo tiene tablas. «Solo texto» es el más barato
        pero no extrae tablas.
      </p>
    </div>
  );
}
